<template>
  <v-layout row wrap class="condominium-box mb-3 pt-3 pb-2 pl-3 pr-3">
    <v-flex xs12 mb-2>
      <h6>Comunicação</h6>
    </v-flex>
    <v-flex xs12 mb-2>
      <v-divider></v-divider>
    </v-flex>
    <v-flex v-show="!scheduleDone" >
      <iframe name="printf" id="printf" @load="frameLoaded" style="display:none;"></iframe>
      <v-btn :disabled="loadingScheduleActions" flat color="blue darken-3" @click="print"><v-icon class="mr-2">print</v-icon> imprimir comunicado</v-btn>
    </v-flex>
    <v-flex xs12 mb-2 v-show="!scheduleDone">
      <v-divider></v-divider>
    </v-flex>
    <v-flex v-if="scheduleDone && schedule.sent">
      <p class="green--text mt-2">
        <v-icon color="green" class="pr-2">check</v-icon>
       {{ schedule.unitCount }} unidades notificadas e {{ schedule.condominiumsCount + schedule.sindicatesCount}} e-mails enviados
     </p>
    </v-flex>
    <v-flex v-else-if="scheduleDone && !schedule.sent">
      <p class="mt-3">
        Não foi divulgado nenhum email para os condôminos
      </p>
    </v-flex>
    <v-flex v-else-if="schedule.sent">
      <p class="green--text mt-2">
        <v-icon color="green" class="pr-2">check</v-icon>
        {{ schedule.unitCount }} unidades notificadas e {{ schedule.condominiumsCount + schedule.sindicatesCount}} e-mails enviados
     </p>
    </v-flex>
        <!-- <v-flex class="pt-2 pb-2 pl-3 alert-emails" v-show="false">
          <v-icon class="pr-2">room_service</v-icon>
          <span>
           {{ schedule.ordersCount }} pedidos foram realizados
          </span>
        </v-flex> -->

    <!--  Primeira divulgação -->
    <v-flex class="" v-else>
      <v-btn @click="sendEmailModal = true" :disabled="loadingScheduleActions" flat color="blue darken-3"><v-icon class="pr-2">email</v-icon> Divulgar este agendamento via e-mail</v-btn>
      <v-dialog v-model="sendEmailModal" scrollable full-width max-width='933'>
        <v-card class="pl-5 pr-5 no-details">
          <v-card-title class="pa-0 pt-4 pb-3">
            <v-flex>
              <h6>
                Comunicado para o condômino
              </h6>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex class="text-xs-right">
              <v-btn class="ma-0" icon @click.native="sendEmailModal = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-layout row wrap>
              <v-flex>
                <p>
                  Estamos enviando um email ao gerente e síndico do condomínio para que autorize a comunicação aos condôminos. Após a autorização, o disparo dos e-mails aos condôminos será automático.
                  <!-- Ao clicar em ENVIAR, será disparado um e-mail aos condôminos que informará sobre o item: <strong style="text-transform:uppercase;">{{ schedule.item.name }}</strong> e a sua oferta. -->
                </p>
                <p>
                  <strong class="red--text">ATENÇÃO</strong>: o envio deste e-mail será realizado APENAS UMA VEZ. Tenha CERTEZA que o agendamento no condomínio está confirmado.
                </p>
              </v-flex>
              <v-flex xs12 class="text-xs-center">
                <v-btn round outline dark color="green" class="mb-3" @click="sendEmail">Enviar</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'send-email',
  props: ['value'],
  data () {
    return {
      printIt: false
    }
  },
  methods: {
    sendEmail () {
      this.$store.dispatch('sendEmail')
    },
    frameLoaded () {
      if (this.printIt) {
        window.frames['printf'].focus()
        window.frames['printf'].print()
        this.printIt = false
      }
    },
    print () {
      document.getElementById('printf').srcdoc = this.schedule.urlComunicado
      this.printIt = true
    }
  },
  computed: {
    loadingScheduleActions () {
      return this.$store.getters.loadingScheduleActions
    },
    scheduleDone () {
      return this.$store.getters.scheduleDone
    },
    schedule () {
      return this.$store.getters.selectedSchedule
    },
    sendEmailModal: {
      get () {
        return this.$store.getters.sendEmailModal
      },
      set (value) {
        if (this.schedule.disponibility.end === null) {
          this.$store.commit('toastr', {
            color: 'info',
            texto: 'Configure a capacidade de atendimento'
          })
        } else {
          this.$store.commit('toggleSendEmailModal', value)
        }
      }
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// SendEmail.vue?34cce415